import { render, staticRenderFns } from "./GroupSettingRightsOfAdministrators.vue?vue&type=template&id=56416b38&scoped=true"
import script from "./GroupSettingRightsOfAdministrators.vue?vue&type=script&lang=js"
export * from "./GroupSettingRightsOfAdministrators.vue?vue&type=script&lang=js"
import style0 from "./GroupSettingRightsOfAdministrators.vue?vue&type=style&index=0&id=56416b38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56416b38",
  null
  
)

export default component.exports